import { render } from "./ChatSummary.vue?vue&type=template&id=b5d6a118&scoped=true"
import script from "./ChatSummary.vue?vue&type=script&lang=js"
export * from "./ChatSummary.vue?vue&type=script&lang=js"

import "./ChatSummary.vue?vue&type=style&index=0&id=b5d6a118&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b5d6a118"]])

export default __exports__